import Ajax from 'adaptive-ui/src/js/utils/ajax';

export default class DeliveryCountrySelector {

    constructor(root) {
        this.root = root;
        this.modalInstance = null;
        this.autoMode = this.root.querySelector('[data-delivery-country-selector-auto]') !== null;

        const trigger = this.root.querySelector('[data-delivery-country-selector-trigger]');

        if (trigger !== null) {
            trigger.addEventListener('click', () => this.openModal());
        }

        if (this.autoMode) {
            this.openModal();
        }
    }

    openModal() {
        const template = this.root.querySelector('[data-delivery-country-selector-template]');

        if (template === null) {
            return;
        }

        this.modalInstance = new window.aui.modal({
            title: template.dataset.deliveryCountrySelectorTitle,
            class: 'delivery-country-selector-modal',
            body: template.innerHTML,
            type: 'sm',
            selfClose: false,
            buttons: {
                close: {
                    isVisible: !this.autoMode,
                },
            },
        });

        this.modalInstance.options.el.addEventListener('click', (event) => {
            const choice = event.target.closest('[data-delivery-country-selector-choice]');

            if (choice !== null) {
                event.preventDefault();
                this.selectCountry(choice.href);
            }
        });
    }

    selectCountry(url) {
        Ajax.get(url, {}, { history: false }).then(() => {
            if (this.modalInstance !== null) {
                this.modalInstance.close();
                this.modalInstance = null;
            }
        });
    }

    static init(container) {
        container.querySelectorAll('[data-delivery-country-selector]').forEach((root) => {
            new DeliveryCountrySelector(root);
        });
    }

}

naja.addEventListener('init', () => {
    DeliveryCountrySelector.init(document.body);
});

naja.snippetHandler.addEventListener('afterUpdate', (event) => {
    DeliveryCountrySelector.init(event.detail.snippet);
});
